/**
 * ═══════════════════════════════════════════════════════════════════════════════════════
 * SỐ 0 MANG NGHĨA KHÁC — và nó không được hiện ra thành một số 0 trần.
 *
 * dev_device nêu đích danh `ovUvChoDongS = 0` phải hiện *"60 giây (mặc định)"*. Tôi đi đếm
 * xem còn chỗ nào cùng bệnh — hợp đồng có **năm** trường mà 0 mang nghĩa riêng:
 *
 *     modbusModel   = 0  →  KHÔNG LẮP            `kapp_settings_p2.proto:47`
 *     elrModel      = 0  →  KHÔNG LẮP            `:57`
 *     elSetMa       = 0  →  TẮT chống rò         `:60`
 *     ovUvTreS      = 0  →  mặc định 5 giây      `:82`
 *     ovUvChoDongS  = 0  →  mặc định 60 giây     `:83`
 *
 * ⛔ NHƯNG BẢNG NÀY CHỈ CÓ **HAI** DÒNG, và đó là chỗ đáng đọc nhất trong tệp:
 *
 *   · `modbusModel` · `elrModel` đi bằng **ô CHỌN** (`o.chon`) — trên màn hình chúng đã hiện
 *     chữ *"Không lắp"*, không bao giờ hiện số 0. Không có bệnh để chữa.
 *   · `elSetMa` đi bằng widget riêng `HangLop`, và câu nghĩa của nó đã nằm ở `canhBaoSo0`.
 *
 *   ⇒ Thêm ba dòng ấy vào đây là **đẻ ra bản sao thứ hai của một câu đã có**, đúng cái bệnh
 *     `TEN_LENH` gõ song song mà tôi đã cắt bốn lần. Chữa cái bệnh KHÔNG phải là gõ lại mọi
 *     trường có số 0 — mà là **chỉ vá đúng chỗ đang hở**.
 *
 * ⚠ VÀ `canhBaoSo0` TRẢ LỜI MỘT CÂU KHÁC, đừng gộp: nó hỏi *"bạn sắp GỬI số 0 — biết nghĩa
 *   chưa?"* (trước khi ghi). Tệp này hỏi *"tủ ĐANG là 0 — nghĩa là gì?"* (khi đọc). Hai thời
 *   điểm, hai người đọc. Gộp lại thì một trong hai sẽ hiện sai lúc.
 *
 * ⛔ KHÔNG ĐỔI CON SỐ TRONG Ô NHẬP. Ô ấy là thứ **sẽ được gửi xuống tủ**: vẽ `60` vào chỗ đang
 *   lưu `0` là nói dối về cái sắp gửi, và lần bấm "Ghi" kế tiếp gửi một số người dùng chưa
 *   từng gõ. Số giữ nguyên; câu chú đứng CẠNH nó.
 *
 * ⚠ Con số mặc định (5 · 60) là **bản sao thứ hai** của một sự thật sống trong chú thích
 *   `.proto`, và web không nhập được từ đó. Bộ kiểm buộc từng dòng ở đây khớp với chính chú
 *   thích ấy — dev_device đổi `60` thành số khác thì phép ĐỎ, không phải đợi ai nhớ.
 *   Cùng khuôn `MA_NGUON_GIU` ↔ enum `.proto`.
 * ═══════════════════════════════════════════════════════════════════════════════════════
 */

export interface NghiaSoKhong {
  /** Câu hiện CẠNH ô nhập khi tủ đang giữ giá trị 0. */
  cau: string;
  /** Số tủ sẽ dùng thay cho 0. */
  macDinh: number;
}

export const NGHIA_SO_KHONG: Record<string, NghiaSoKhong> = {
  ovUvChoDongS: { cau: '= 60 giây (mặc định của tủ)', macDinh: 60 },
  ovUvTreS: { cau: '= 5 giây (mặc định của tủ)', macDinh: 5 },
};

/**
 * Câu chú cho một ô, hoặc `null` khi không có gì để nói.
 *
 * ⛔ CHỈ khi giá trị ĐÚNG BẰNG 0. `undefined` (chưa đọc được từ tủ) KHÔNG phải 0 — đó là
 *   *"chưa biết"*, và vẽ *"= 60 giây (mặc định)"* cho một ô chưa đọc được là khẳng định một
 *   điều tủ chưa nói. Cùng luật `'chua-biet'` ≠ `'khong-ai'` (NV108).
 */
export function nghiaSoKhong(ten: string, giaTri: number | undefined | null): string | null {
  if (giaTri !== 0) return null;
  return NGHIA_SO_KHONG[ten]?.cau ?? null;
}
